module.exports = __webpack_public_path__ + "img/new.ac28a0b7.png";